module.exports = {
    TRACKING: {
        acura: {
            'rlx': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9584106.142314486;dc_trk_aid=315415113;' +
                'dc_trk_cid=62062043;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'tlx': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9584106.142320656;dc_trk_aid=315409667;' +
                'dc_trk_cid=62013615;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'mdx': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9584106.142320770;dc_trk_aid=315552644;' +
                'dc_trk_cid=62060969;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'ilx': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9584106.142321031;dc_trk_aid=315410895;' +
                'dc_trk_cid=62061818;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'rdx': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9584106.142321032;dc_trk_aid=315414617;' +
                'dc_trk_cid=62011569;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            }
        },
        'alfa-romeo': {
            'giulia': {
                link: 'https://ad.doubleclick.net/ddm/clk/315603817;143547838;m'
            },
            '4c': {
                link: 'https://ad.doubleclick.net/ddm/clk/315603817;143547842;h'
            },
            '4c-spider': {
                link: 'https://ad.doubleclick.net/ddm/clk/315596479;143547903;u'
            }
        },
        nissan: {
            'altima': {
                link: 'https://ad.doubleclick.net/ddm/clk/315392379;142244366;j'
            },
            'armada': {
                link: 'https://ad.doubleclick.net/ddm/clk/315399968;142244363;r'
            },
            'frontier': {
                link: 'https://ad.doubleclick.net/ddm/clk/315406423;142244369;y'
            },
            'juke': {
                link: 'https://ad.doubleclick.net/ddm/clk/315410992;142244372;y'
            },
            'leaf': {
                link: 'https://ad.doubleclick.net/ddm/clk/315464281;142244375;b'
            },
            'maxima': {
                link: 'https://ad.doubleclick.net/ddm/clk/315467769;142244381;m'
            },
            'murano': {
                link: 'https://ad.doubleclick.net/ddm/clk/315477360;142244378;g'
            },
            'pathfinder': {
                link: 'https://ad.doubleclick.net/ddm/clk/315482225;142244385;a'
            },
            'quest': {
                link: 'https://ad.doubleclick.net/ddm/clk/315469129;142244388;l'
            },
            'rogue': {
                link: 'https://ad.doubleclick.net/ddm/clk/315467387;142244392;k'
            },
            'sentra': {
                link: 'https://ad.doubleclick.net/ddm/clk/315467895;142244395;r'
            },
            'titan': {
                link: 'https://ad.doubleclick.net/ddm/clk/315476219;142244399;l'
            },
            'titan-xd': {
                link: 'https://ad.doubleclick.net/ddm/clk/315477353;142247209;e'
            },
            'versa-note': {
                link: 'https://ad.doubleclick.net/ddm/clk/315478224;142247203;w'
            },
            'versa': {
                link: 'https://ad.doubleclick.net/ddm/clk/315477361;142247206;a'
            },
            'nv200': {
                link: 'https://ad.doubleclick.net/ddm/clk/315623635;142705437;c'
            },
            'nv-passenger': {
                link: 'https://ad.doubleclick.net/ddm/clk/315327971;142705018;b'
            },
            'nv-cargo': {
                link: 'https://ad.doubleclick.net/ddm/clk/315623190;142705017;s'
            }
        },
        chevrolet: {
            'cruze-limited': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142593465;dc_trk_aid=314940101;' +
                'dc_trk_cid=76158335;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'cruze': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142592288;dc_trk_aid=314940101;' +
                'dc_trk_cid=76158335;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'equinox': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142594236;dc_trk_aid=314931392;' +
                'dc_trk_cid=76159178;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'malibu-limited': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142591878;dc_trk_aid=314931399;' +
                'dc_trk_cid=76202823;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'malibu': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142592589;dc_trk_aid=314931399;' +
                'dc_trk_cid=76202823;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'silverado-1500': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142592592;dc_trk_aid=314931389;' +
                'dc_trk_cid=76198236;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'silverado-2500hd': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142592591;dc_trk_aid=314940102;' +
                'dc_trk_cid=75717642;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'silverado-3500hd': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142594428;dc_trk_aid=314931387;' +
                'dc_trk_cid=75711590;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'spark-ev': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142592593;dc_trk_aid=314940105;' +
                'dc_trk_cid=75706056;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'spark': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142593467;dc_trk_aid=314940103;' +
                'dc_trk_cid=75704753;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'suburban': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142593279;dc_trk_aid=314931397;' +
                'dc_trk_cid=75716665;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'traverse': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142593075;dc_trk_aid=314931396;' +
                'dc_trk_cid=76205207;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'volt': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142593466;dc_trk_aid=314940106;' +
                'dc_trk_cid=76205220;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            }
        },
        jeep: {
            '': {
                link: 'https://ad.doubleclick.net/ddm/clk/315741805;143890323;c'
            },
            'compass': {
                link: 'https://ad.doubleclick.net/ddm/clk/315748242;143909053;f'
            },
            'cherokee': {
                link: 'https://ad.doubleclick.net/ddm/clk/315748231;143908951;j'
            },
            'grand-cherokee': {
                link: 'https://ad.doubleclick.net/ddm/clk/315748236;143909051;g'
            },
            'patriot': {
                link: 'https://ad.doubleclick.net/ddm/clk/315747237;143908949;v'
            },
            'renegade': {
                link: 'https://ad.doubleclick.net/ddm/clk/315748238;143890322;i'
            },
            'wrangler': {
                link: 'https://ad.doubleclick.net/ddm/clk/315747239;143910239;i'
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/deep-link/deep-link-constants2.js
// module id = 147
// module chunks = 0 1 23